module.exports = __webpack_public_path__ + "static/media/0_2019_07_05.24215d5a.jpg";